import { ClientPagination } from "../constants/Pagination";

export const GLOTTIS_POST_LOGIN = "/user/login";
export const FORGET_PASSWORD = "/user/forgot-password-token";
export const FORGET_PASSWORD_RESEND_CODE = "/user/forgot-password-resend-token";
export const RESET_PASSWORD_URL = "/user/forgot-password-reset";

//CLIENTS
// export const GET_CLIENTS ="/client/getAll/1/";
export const GET_CLIENTS = `/client/getAll/0/0`;
export const POST_NEW_CLIENT = "/client/create-new";
export const UPDATE_CLIENT = "/client";
export const CLIENT_STATUS = "/client/client-status";

// admin
export const GET_ALL_ADMIN = "/user/getAdmins/0/0";
export const POST_NEW_ADMIN = "/user/create-new";
export const GET_ADMIN_BY_ID = "/user";
export const UPDATE_STATUS = "/user/user-status";
export const GET_ADMIN_ROLES = "/user/getRoles";

// user
export const GET_ALL_USER = "/user/getClientUsers/0/0";
export const POST_NEW_USER = "/user/create-new";
export const GET_USER_BY_ID = "/user";
export const DELETE_USER = "/user/delete-user";

//Booking
export const GET_ALL_BOOKINGS = '/booking/getAll/0/0'

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";
//Quotes
export const POST_NEW_QUOTES_SEA_EXPORT_GENERAL_CARGO = "/quotes/new";
export const GET_ALL_QUOTES = "/quotes/getAll";
export const GET_BY_ID_QUOTES = "/quotes";
export const DELETE_QUOTE = "/quotes/delete-quote";
export const QUOTE_STATUS_UPDATE = "/quotes/update-status";
export const ADD_AIR_SHIPPER_INFO = "/quotes/shipper/air/save";
export const GET_BY_ID_AIR_SHIPPER_INFO = "/quotes/shipper-air";
export const ADD_SEA_SHIPPER_INFO = "/quotes/shipper/sea/save";
export const GET_BY_ID_SEA_SHIPPER_INFO = "/quotes/shipper-sea";
export const AIR_SHIPPER_INFO_STATUS_UPDATE = "/quotes/update-air-shipper-information-status";
export const SEA_SHIPPER_INFO_STATUS_UPDATE = "/quotes/update-sea-shipper-information-status";

//Generate password
export const GENERATE_PASSWORD = "/user/reset-password-user";

//Dashboard
export const GET_COUNTS = "/dashboard/get-card-count"; //total - super admins, admins, users, bookings and quotes
export const GET_RECENT_QUOTES = "/user/recent-quotes";
export const GET_PIE_CHART = "/dashboard/get-booking-division-count";
export const GET_BAR_CHART = "/dashboard/get-booking-division-count-by-month";
export const UPDATE_PROFILE = "/user/update-profile";
export const CHANGE_PASSWORD = "/user/update-password";

//tracking
export const TRACK_BOOKING = '/shipment/get-shipment-with-reference'
export const GET_BOOKING_BY_BOOKING_NO = '/booking'
export const GET_BOOKING_BY_CONTAINER_WISE = '/booking'

//update profile image
export const UPDATE_PROFILE_IMG = "/user/update-profile-img";

//settings
export const SETTINGS_UPDATE = "/settings/update";
export const GET_SETTINGS = "/settings/get-all";
export const GET_NOTIFICATION = "/settings/notification";